export interface NextInList<T> {
    next: T;
    // Cases after the current one across the whole list, `next` included.
    remaining: number;
}

export function nextInList<T extends { id: string }>(
    rows: readonly T[],
    caseId: string,
    rowsBefore: number,
    total: number
): NextInList<T> | null {
    const index = rows.findIndex((row) => row.id === caseId);
    const next = index === -1 ? undefined : rows[index + 1];
    if (!next) return null;
    return { next, remaining: total - (rowsBefore + index + 1) };
}

export type SnapshotAction = 'keep' | 'rebuild' | 'clear' | 'wait';

// Continue closes and reopens the same task, so a pending Continue must not clear the snapshot.
export function snapshotAction(
    snapshotCaseId: string | null,
    activeTaskCaseId: string | null,
    continuePending: boolean,
    listLoaded: boolean
): SnapshotAction {
    if (!activeTaskCaseId) return snapshotCaseId && !continuePending ? 'clear' : 'keep';
    if (snapshotCaseId === activeTaskCaseId) return 'keep';
    return listLoaded ? 'rebuild' : 'wait';
}
